import { LocalStorageCommandSubscriber } from '@atlassian/jira-portfolio-3-local-storage-commands/src/ui/subscriber/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import mapDispatchToProps from './command.tsx';

export default connect(null, mapDispatchToProps)(LocalStorageCommandSubscriber);
